import styled, { css } from 'styled-components'

export const Container = styled.div`
  width: 100%;

  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.1);
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
`

interface ITHContainer {
  selected?: boolean
}

export const THContainer = styled.div<ITHContainer>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${(props) =>
    props.selected &&
    css`
      && {
        color: var(--table-color-selected);
      }
    `}
`

export const ResponsiveContainer = styled.div`
  width: 100%;

  overflow-y: auto;

  table {
    width: 100%;
    min-width: 767px;
  }
`

export const Table = styled.table`
  border: 1px solid var(--table-border-color);
  border-spacing: 0;
  color: var(--table-color);

  tr {
    height: 3rem;
  }

  th,
  td {
    font-weight: 400;
    text-align: start;
    padding: 1rem 1.5rem;
  }

  thead {
    font-size: 1.1rem;
    background-color: var(--thead-background);
    color: var(--table-color);
  }

  tbody {
    font-size: 1rem;

    tr {
      td {
        border-bottom: 1px solid var(--table-border-color);
      }

      &:last-child {
        td {
          border-bottom: 0;
        }
      }

      &:hover {
        background: var(--tbody-background-hover);
        backdrop-filter: blur(2px);
        color: var(--tbody-color-hover);
      }
    }
  }
`

export const Header = styled.header`
  border: 1px solid var(--table-border-color);
  border-bottom: 0;
  min-height: 3rem;
  padding: 0.5rem 1.5rem;
  border-radius: 4px 4px 0 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    flex-direction: center;
    padding: 1rem 1.5rem;
  }

  h1 {
    font-weight: 400;
    font-size: 1.5rem;
    line-height: auto;
    margin: 0;
    margin-right: 1rem;

    @media (max-width: 767px) {
      margin-bottom: 0.5rem;
    }
  }
`

export const Footer = styled.footer`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  min-height: 3rem;

  padding: 0.5rem 1.5rem;

  border: 1px solid var(--table-border-color);
  border-top: 0;
  border-radius: 0 0 4px 4px;
`
